import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const AutoFixButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "m-y-1",
    children: /*#__PURE__*/_jsx(UIButton, {
      onClick: () => onClick(),
      size: "small",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.actions.FIX_H1_TAGS"
      })
    })
  });
};